module.exports = __webpack_public_path__ + "img/flavor6.64513b7b.png";